import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetLinkedByHierarchiesQueryVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  depth?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetLinkedByHierarchiesQuery = { getLinkedByHierarchies: Array<{ hierarchyId: string, hierarchyCode: string, totalCount: number, objectSchemaCode: string }> };

export type ContentTranslationQueryVariables = Types.Exact<{
  fromIsoCode: Types.Scalars['String'];
  toIsoCode: Types.Scalars['String'];
  content: Types.Scalars['String'];
  type: Types.Scalars['String'];
}>;


export type ContentTranslationQuery = { contentTranslation: string };

export type GetInheritAncestorNodeQueryVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  contentTypeGroup: Types.Scalars['String'];
  contentType: Types.Scalars['String'];
  contentTypeGroupIndex: Types.Scalars['Int'];
}>;


export type GetInheritAncestorNodeQuery = { inheritAncestorNode: string };

export type CheckPrototypesMmDispoQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  pendingSelections?: Types.InputMaybe<Array<Types.PrototypeMmDispoSelectionInput> | Types.PrototypeMmDispoSelectionInput>;
}>;


export type CheckPrototypesMmDispoQuery = { getPrototypesMMDispoValidity: Array<{ prototypeId: string, prototypeCode: string, errors: Array<{ position: string, gls: Array<{ id: string, code: string, value?: string | null, label?: string | null }> }>, values: Array<{ position: string, gl?: { id: string, code: string, value?: string | null, label?: string | null } | null }> }> };

export type ContentTranslationApprovalMutationVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  contentType: Types.Scalars['String'];
  contentTypeGroup: Types.Scalars['String'];
  contentTypeGroupIndex: Types.Scalars['Int'];
  languageIsoCode: Types.Scalars['String'];
}>;


export type ContentTranslationApprovalMutation = { contentTranslationApproval?: boolean | null };

export type UpdatePermissionsMutationVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  readRoles: Array<Types.Scalars['String']> | Types.Scalars['String'];
  writeRoles: Array<Types.Scalars['String']> | Types.Scalars['String'];
  readUsers: Array<Types.Scalars['String']> | Types.Scalars['String'];
  writeUsers: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type UpdatePermissionsMutation = { updatePermissions?: { code: string, message: string, success: boolean, propagationJobId?: string | null } | null };

export type ApproveContentTypeGroupMutationVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  contentTypeGroup?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ApproveContentTypeGroupMutation = { approveContentTypeGroup?: { code: string, message: string, success: boolean } | null };

export type UpdateTranslationStatisticsMutationVariables = Types.Exact<{
  modifiedCount: Types.Scalars['Int'];
  keptAsReceivedCount: Types.Scalars['Int'];
}>;


export type UpdateTranslationStatisticsMutation = { updateTranslationStatistics?: { code: string, message: string } | null };

export type GetOneHierarchyQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
  pagination?: Types.InputMaybe<Types.Pagination>;
  nodeFilters?: Types.InputMaybe<Types.NodeFilter>;
}>;


export type GetOneHierarchyQuery = { hierarchies?: Array<{ id: string, code: string, nodes: Array<{ id: string, code: string, parent: string, parentCode?: string | null, hasChildren?: boolean | null, totalChildren?: number | null, linkedBy?: Array<{ code: string, nodeId: string, hierarchyId: string } | null> | null }> }> | null };

export type CreateHierarchyMutationVariables = Types.Exact<{
  objectSchema: Types.Scalars['String'];
  code: Types.Scalars['String'];
}>;


export type CreateHierarchyMutation = { createHierarchy?: { code: string, message: string } | null };

export type DuplicateHierarchyMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  code: Types.Scalars['String'];
  market?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type DuplicateHierarchyMutation = { duplicateHierarchy?: { code: string, message: string } | null };

export type CreateNodeMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  code: Types.Scalars['String'];
  parent: Types.Scalars['String'];
}>;


export type CreateNodeMutation = { createNode?: { code: string, message: string, success: boolean } | null };

export type UpdateNodeCodeMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  parent: Types.Scalars['String'];
  node: Types.Scalars['String'];
  code: Types.Scalars['String'];
}>;


export type UpdateNodeCodeMutation = { updateNode?: { code: string, message: string, success: boolean } | null };

export type UpdateHierarchyCodeMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  objectSchema: Types.Scalars['String'];
  code: Types.Scalars['String'];
}>;


export type UpdateHierarchyCodeMutation = { updateHierarchy?: { code: string, message: string, success: boolean } | null };

export type SetContentMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  parent?: Types.InputMaybe<Types.Scalars['String']>;
  node: Types.Scalars['String'];
  contents: Array<Types.NodeContent> | Types.NodeContent;
  isCreate?: Types.InputMaybe<Types.Scalars['Boolean']>;
  skipTranslation: Types.Scalars['Boolean'];
}>;


export type SetContentMutation = { updateNodeContent?: { code: string, message: string, success: boolean } | null };

export type UpdatePrototypeMutationVariables = Types.Exact<{
  node: Types.Scalars['String'];
  contents: Array<Types.NodeContent> | Types.NodeContent;
  skipTranslation: Types.Scalars['Boolean'];
}>;


export type UpdatePrototypeMutation = { updatePrototype?: { code: string, message: string, success: boolean } | null };

export type UpdateBulkNodesContentsMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  nodes: Array<Types.BulkNodes> | Types.BulkNodes;
}>;


export type UpdateBulkNodesContentsMutation = { updateBulkNodesContents?: { code: string, message: string, success: boolean } | null };

export type UpdateNodeParentMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  node: Types.Scalars['String'];
  parent: Types.Scalars['String'];
}>;


export type UpdateNodeParentMutation = { updateNodeParent?: { code: string, message: string, success: boolean } | null };

export type PublishMutationVariables = Types.Exact<{
  hierarchy: Types.Scalars['String'];
  node: Types.Scalars['String'];
  contentTypeGroups: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type PublishMutation = { publish?: { code: string, success: boolean, message: string } | null };

export type UnpublishNodeMutationVariables = Types.Exact<{
  hierarchy: Types.Scalars['String'];
  node: Types.Scalars['String'];
}>;


export type UnpublishNodeMutation = { unpublish?: { code: string, success: boolean, message: string } | null };

export type ToggleDisabledMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  node: Types.Scalars['String'];
}>;


export type ToggleDisabledMutation = { toggleDisabled?: { code: string, success: boolean, message: string } | null };

export type HierarchiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HierarchiesQuery = { hierarchies?: Array<{ id: string, code: string }> | null };

export type GetCsvUploadDataQueryVariables = Types.Exact<{
  nodeId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetCsvUploadDataQuery = { hierarchies?: Array<{ id: string, objectSchema?: { contentTypeGroups?: Array<{ code: string, repeatable: boolean, name: Array<{ languageIsoCode: string, value: string }>, contentTypes?: Array<{ type: string, code: string, multiLanguage: boolean, multiValue: boolean, mandatory: boolean, hierarchy?: string | null, mandatoryForSave?: { isMandatory?: boolean | null, option?: string | null, comparator?: string | null, value?: string | null } | null, name: Array<{ languageIsoCode: string, value: string }> }> | null }> | null } | null }> | null };

export type GetHierarchyNodesQueryVariables = Types.Exact<{
  hierarchiesId?: Types.InputMaybe<Types.Scalars['String']>;
  filters?: Types.InputMaybe<Types.NodeFilter>;
}>;


export type GetHierarchyNodesQuery = { hierarchies?: Array<{ nodes: Array<{ id: string, code: string }> }> | null };

export type GetObjectSchemaQueryVariables = Types.Exact<{
  hierarchiesId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetObjectSchemaQuery = { hierarchies?: Array<{ objectSchema?: { code: string } | null }> | null };

export type GetObjectSchemaDetailQueryVariables = Types.Exact<{
  hierarchiesId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetObjectSchemaDetailQuery = { hierarchies?: Array<{ id: string, code: string, objectSchema?: { id: string, code: string, automaticParentCreation?: boolean | null, disableDeleteHierarchy?: boolean | null, disableDelete?: boolean | null, disableEditCode?: boolean | null, contentTypeGroups?: Array<{ code: string, repeatable: boolean, roles?: string | null, name: Array<{ languageIsoCode: string, value: string }>, contentTypes?: Array<{ code: string, hierarchy?: string | null, type: string, multiLanguage: boolean, multiValue: boolean, mandatory: boolean, kind?: string | null, workflowCode?: string | null, link?: Array<string | null> | null, search?: string | null, depthFilter?: string | null, hidden?: boolean | null, regex?: string | null, readOnly?: boolean | null, inheritedReadOnly?: boolean | null, autoFilled?: boolean | null, enableRange?: boolean | null, allowPastDates?: boolean | null, showAsPercentage?: boolean | null, disableThousandsSeparator?: boolean | null, columnSize?: string | null, encryptAtRest?: boolean | null, maskOnUi?: boolean | null, name: Array<{ languageIsoCode: string, value: string }>, optionalValues?: Array<{ code: string, value: Array<{ languageIsoCode: string, value: string }> }> | null, optionsSource?: { kind: string, contentTypeCode?: string | null } | null, mandatoryForSave?: { isMandatory?: boolean | null, option?: string | null, comparator?: string | null, value?: string | null } | null, filters?: Array<{ code: string, value: string, comparator: Types.SearchFilterOperator, id: string, editable?: boolean | null }> | null, dynamicFilters?: Array<{ code: string, value: string, comparator: Types.SearchFilterOperator, id: string, editable?: boolean | null }> | null, dynamicRegex?: Array<{ regex: string, option: string, comparator: string, value: string, id: string }> | null, visibility?: { operator?: string | null, visibilityRules?: Array<{ option: string, comparator: string, value: string, id: string }> | null } | null, dynamicReadonly?: { operator?: string | null, message?: string | null, dynamicReadonlyRules?: Array<{ kind?: string | null, option: string, comparator: string, value: string, id: string }> | null } | null }> | null }> | null } | null }> | null };

export type GetNodeCodeQueryVariables = Types.Exact<{
  hierarchiesId?: Types.InputMaybe<Types.Scalars['String']>;
  nodeFilter?: Types.InputMaybe<Types.NodeFilter>;
}>;


export type GetNodeCodeQuery = { hierarchies?: Array<{ id: string, nodes: Array<{ id: string, code: string, listName?: string | null, writeRoles?: Array<string> | null, writeUsers?: Array<string> | null }> }> | null };

export type GetNodeQueryVariables = Types.Exact<{
  hierarchiesId?: Types.InputMaybe<Types.Scalars['String']>;
  nodeFilter?: Types.InputMaybe<Types.NodeFilter>;
  isInTranslation?: Types.InputMaybe<Types.Scalars['Boolean']>;
  transformNodes?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type GetNodeQuery = { hierarchies?: Array<{ id: string, code: string, nodes: Array<{ id: string, _rev?: string | null, code: string, parent: string, listName?: string | null, disabled?: boolean | null, readRoles?: Array<string> | null, writeRoles?: Array<string> | null, readUsers?: Array<string> | null, writeUsers?: Array<string> | null, nodePublished: Types.CtgStatus, createdAt: number, updatedAt: number, readonlyState?: { locked: boolean, excludedFields: Array<string>, message?: string | null, error?: string | null } | null, contentTypeGroupStatus?: Array<{ code: string, status: Types.CtgStatus, publishedAt?: string | null }> | null, contents?: Array<{ contentType: string, contentTypeGroup: string, contentTypeGroupIndex: number, type: string, inherited: boolean, valueDecryptionFailed?: boolean | null, value?: Array<{ code?: string | null, value: Array<any | null>, languageIsoCode: string, measure?: string | null, translate?: boolean | null, approvedValue?: Array<any | null> | null, translating?: boolean | null, autoGenerated?: boolean | null }> | null }> | null, linkedBy?: Array<{ code: string, nodeId: string, hierarchyId: string, listName?: string | null, order?: string | null, linkedNodes?: Array<{ code: string, nodeId: string, hierarchyId: string, listName?: string | null, order?: string | null } | null> | null } | null> | null, metadata?: { updatedBy?: string | null } | null, assignedOwner?: { id: string, code: string, listName?: string | null } | null, assignedDealership?: { id: string, code: string, listName?: string | null } | null, assignedClient?: { id: string, code: string, listName?: string | null } | null, assignedMarket?: { id: string, code: string, listName?: string | null } | null }>, objectSchema?: { id: string, code: string, codeCreationExpression?: string | null, automaticParentCreation?: boolean | null, codeLabel?: string | null, showListNameInEdit?: boolean | null, enablePublish?: boolean | null, bulkPublish?: boolean | null, showPublishInfo?: boolean | null, enableOwner?: boolean | null, hideDisableToggle?: boolean | null, hideDisableToggleDepths?: Array<number> | null, hideChangeParent?: boolean | null, linkedNodeDeleteStrategy?: Types.LinkedNodeDeleteStrategy | null, disableDeleteHierarchy?: boolean | null, disableDelete?: boolean | null, disableEditCode?: boolean | null, isReferenced: boolean, contentTypeGroups?: Array<{ showLevel?: string | null, code: string, repeatable: boolean, collapsed?: boolean | null, roles?: string | null, approveRoles?: string | null, name: Array<{ languageIsoCode: string, value: string }>, contentTypes?: Array<{ code: string, hierarchy?: string | null, type: string, multiLanguage: boolean, multiValue: boolean, multiLine?: boolean | null, allowExternalUrl?: boolean | null, mandatory: boolean, mediaFolder?: string | null, disableNodeCreation?: boolean | null, disableEditAction?: boolean | null, enableXlsxExport?: boolean | null, compactView?: boolean | null, creatable?: boolean | null, showCode?: boolean | null, workflowCode?: string | null, allowDuplicateOptionsCode?: boolean | null, disallowEqualCodeAndValue?: boolean | null, kind?: string | null, link?: Array<string | null> | null, search?: string | null, depthFilter?: string | null, hidden?: boolean | null, regex?: string | null, readOnly?: boolean | null, inheritedReadOnly?: boolean | null, autoFilled?: boolean | null, enableRange?: boolean | null, allowPastDates?: boolean | null, showAsPercentage?: boolean | null, disableThousandsSeparator?: boolean | null, columnSize?: string | null, encryptAtRest?: boolean | null, maskOnUi?: boolean | null, name: Array<{ languageIsoCode: string, value: string }>, optionalValues?: Array<{ code: string, value: Array<{ languageIsoCode: string, value: string }> }> | null, optionsSource?: { kind: string, contentTypeCode?: string | null } | null, mandatoryForSave?: { isMandatory?: boolean | null, option?: string | null, comparator?: string | null, value?: string | null } | null, filters?: Array<{ code: string, value: string, comparator: Types.SearchFilterOperator, id: string, editable?: boolean | null }> | null, dynamicFilters?: Array<{ code: string, value: string, comparator: Types.SearchFilterOperator, id: string, editable?: boolean | null }> | null, dynamicRegex?: Array<{ regex: string, option: string, comparator: string, value: string, id: string }> | null, visibility?: { operator?: string | null, visibilityRules?: Array<{ option: string, comparator: string, value: string, id: string }> | null } | null, dynamicReadonly?: { operator?: string | null, message?: string | null, dynamicReadonlyRules?: Array<{ kind?: string | null, option: string, comparator: string, value: string, id: string }> | null } | null, additionalInfo?: Array<{ fieldCode?: string | null, fieldName?: string | null, fieldType?: Types.AdditionalInfoFieldType | null, showOnLinkTable: boolean, hierarchy?: string | null, multiValue?: boolean | null, linkedByRowNode?: boolean | null, jsonDataFormula?: string | null, readonly: boolean } | null> | null }> | null }> | null } | null }> | null };

export type GetNodeChildrenQueryVariables = Types.Exact<{
  hierarchiesId?: Types.InputMaybe<Types.Scalars['String']>;
  nodeFilter?: Types.InputMaybe<Types.NodeFilter>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetNodeChildrenQuery = { hierarchies?: Array<{ id: string, code: string, currentNode: Array<{ id: string, code: string, parent: string, hasChildren?: boolean | null, totalChildren?: number | null }>, nodes: Array<{ id: string, code: string, parent: string, hasChildren?: boolean | null, totalChildren?: number | null, contentTypeGroupStatus?: Array<{ code: string, status: Types.CtgStatus }> | null }>, objectSchema?: { contentTypeGroups?: Array<{ code: string }> | null } | null }> | null };

export type GetNodeDisabledQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['String']>;
  nodeFilter?: Types.InputMaybe<Types.NodeFilter>;
}>;


export type GetNodeDisabledQuery = { hierarchies?: Array<{ id: string, code: string, nodes: Array<{ disabled?: boolean | null }> }> | null };

export type GetShortListBuildupDiffQueryVariables = Types.Exact<{
  shortListId: Types.Scalars['String'];
}>;


export type GetShortListBuildupDiffQuery = { getShortListBuildupDiff: Array<{ familyId: string, prototypes: Array<{ prototypeId: string, prototypeCode: string, fields: Array<{ code: string, certified?: string | null, draft?: string | null }> }> }> };

export type UpdateListNameMutationVariables = Types.Exact<{
  objectSchema: Types.Scalars['String'];
  listName: Types.Scalars['String'];
}>;


export type UpdateListNameMutation = { updateListName?: boolean | null };

export type ChangeNodesOrderMutationVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  parentId: Types.Scalars['String'];
  nodeOrder: Array<Types.OrderNode> | Types.OrderNode;
}>;


export type ChangeNodesOrderMutation = { changeNodesOrder?: { code: string, success: boolean, message: string } | null };

export type AlignModelGlsMutationVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  misalignedGlsIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type AlignModelGlsMutation = { alignModelGls?: { success: boolean, successfullyUpdatedGls: Array<string>, errors: Array<string> } | null };


export const GetLinkedByHierarchiesDocument = gql`
    query GetLinkedByHierarchies($hierarchyId: String!, $nodeId: String!, $depth: String) {
  getLinkedByHierarchies(
    hierarchyId: $hierarchyId
    nodeId: $nodeId
    depth: $depth
  ) {
    hierarchyId
    hierarchyCode
    totalCount
    objectSchemaCode
  }
}
    `;

/**
 * __useGetLinkedByHierarchiesQuery__
 *
 * To run a query within a React component, call `useGetLinkedByHierarchiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedByHierarchiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedByHierarchiesQuery({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *      depth: // value for 'depth'
 *   },
 * });
 */
export function useGetLinkedByHierarchiesQuery(baseOptions: Apollo.QueryHookOptions<GetLinkedByHierarchiesQuery, GetLinkedByHierarchiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedByHierarchiesQuery, GetLinkedByHierarchiesQueryVariables>(GetLinkedByHierarchiesDocument, options);
      }
export function useGetLinkedByHierarchiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedByHierarchiesQuery, GetLinkedByHierarchiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedByHierarchiesQuery, GetLinkedByHierarchiesQueryVariables>(GetLinkedByHierarchiesDocument, options);
        }
export type GetLinkedByHierarchiesQueryHookResult = ReturnType<typeof useGetLinkedByHierarchiesQuery>;
export type GetLinkedByHierarchiesLazyQueryHookResult = ReturnType<typeof useGetLinkedByHierarchiesLazyQuery>;
export type GetLinkedByHierarchiesQueryResult = Apollo.QueryResult<GetLinkedByHierarchiesQuery, GetLinkedByHierarchiesQueryVariables>;
export const ContentTranslationDocument = gql`
    query ContentTranslation($fromIsoCode: String!, $toIsoCode: String!, $content: String!, $type: String!) {
  contentTranslation(
    fromIsoCode: $fromIsoCode
    toIsoCode: $toIsoCode
    content: $content
    type: $type
  )
}
    `;

/**
 * __useContentTranslationQuery__
 *
 * To run a query within a React component, call `useContentTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentTranslationQuery({
 *   variables: {
 *      fromIsoCode: // value for 'fromIsoCode'
 *      toIsoCode: // value for 'toIsoCode'
 *      content: // value for 'content'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useContentTranslationQuery(baseOptions: Apollo.QueryHookOptions<ContentTranslationQuery, ContentTranslationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentTranslationQuery, ContentTranslationQueryVariables>(ContentTranslationDocument, options);
      }
export function useContentTranslationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentTranslationQuery, ContentTranslationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentTranslationQuery, ContentTranslationQueryVariables>(ContentTranslationDocument, options);
        }
export type ContentTranslationQueryHookResult = ReturnType<typeof useContentTranslationQuery>;
export type ContentTranslationLazyQueryHookResult = ReturnType<typeof useContentTranslationLazyQuery>;
export type ContentTranslationQueryResult = Apollo.QueryResult<ContentTranslationQuery, ContentTranslationQueryVariables>;
export const GetInheritAncestorNodeDocument = gql`
    query GetInheritAncestorNode($hierarchyId: String!, $nodeId: String!, $contentTypeGroup: String!, $contentType: String!, $contentTypeGroupIndex: Int!) {
  inheritAncestorNode(
    hierarchyId: $hierarchyId
    nodeId: $nodeId
    contentTypeGroup: $contentTypeGroup
    contentType: $contentType
    contentTypeGroupIndex: $contentTypeGroupIndex
  )
}
    `;

/**
 * __useGetInheritAncestorNodeQuery__
 *
 * To run a query within a React component, call `useGetInheritAncestorNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInheritAncestorNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInheritAncestorNodeQuery({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *      contentTypeGroup: // value for 'contentTypeGroup'
 *      contentType: // value for 'contentType'
 *      contentTypeGroupIndex: // value for 'contentTypeGroupIndex'
 *   },
 * });
 */
export function useGetInheritAncestorNodeQuery(baseOptions: Apollo.QueryHookOptions<GetInheritAncestorNodeQuery, GetInheritAncestorNodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInheritAncestorNodeQuery, GetInheritAncestorNodeQueryVariables>(GetInheritAncestorNodeDocument, options);
      }
export function useGetInheritAncestorNodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInheritAncestorNodeQuery, GetInheritAncestorNodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInheritAncestorNodeQuery, GetInheritAncestorNodeQueryVariables>(GetInheritAncestorNodeDocument, options);
        }
export type GetInheritAncestorNodeQueryHookResult = ReturnType<typeof useGetInheritAncestorNodeQuery>;
export type GetInheritAncestorNodeLazyQueryHookResult = ReturnType<typeof useGetInheritAncestorNodeLazyQuery>;
export type GetInheritAncestorNodeQueryResult = Apollo.QueryResult<GetInheritAncestorNodeQuery, GetInheritAncestorNodeQueryVariables>;
export const CheckPrototypesMmDispoDocument = gql`
    query CheckPrototypesMMDispo($modelId: String!, $pendingSelections: [PrototypeMMDispoSelectionInput!]) {
  getPrototypesMMDispoValidity(
    modelId: $modelId
    pendingSelections: $pendingSelections
  ) {
    prototypeId
    prototypeCode
    errors {
      position
      gls {
        id
        code
        value
        label
      }
    }
    values {
      position
      gl {
        id
        code
        value
        label
      }
    }
  }
}
    `;

/**
 * __useCheckPrototypesMmDispoQuery__
 *
 * To run a query within a React component, call `useCheckPrototypesMmDispoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPrototypesMmDispoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPrototypesMmDispoQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      pendingSelections: // value for 'pendingSelections'
 *   },
 * });
 */
export function useCheckPrototypesMmDispoQuery(baseOptions: Apollo.QueryHookOptions<CheckPrototypesMmDispoQuery, CheckPrototypesMmDispoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckPrototypesMmDispoQuery, CheckPrototypesMmDispoQueryVariables>(CheckPrototypesMmDispoDocument, options);
      }
export function useCheckPrototypesMmDispoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckPrototypesMmDispoQuery, CheckPrototypesMmDispoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckPrototypesMmDispoQuery, CheckPrototypesMmDispoQueryVariables>(CheckPrototypesMmDispoDocument, options);
        }
export type CheckPrototypesMmDispoQueryHookResult = ReturnType<typeof useCheckPrototypesMmDispoQuery>;
export type CheckPrototypesMmDispoLazyQueryHookResult = ReturnType<typeof useCheckPrototypesMmDispoLazyQuery>;
export type CheckPrototypesMmDispoQueryResult = Apollo.QueryResult<CheckPrototypesMmDispoQuery, CheckPrototypesMmDispoQueryVariables>;
export const ContentTranslationApprovalDocument = gql`
    mutation ContentTranslationApproval($hierarchyId: String!, $nodeId: String!, $contentType: String!, $contentTypeGroup: String!, $contentTypeGroupIndex: Int!, $languageIsoCode: String!) {
  contentTranslationApproval(
    hierarchyId: $hierarchyId
    nodeId: $nodeId
    contentType: $contentType
    contentTypeGroup: $contentTypeGroup
    contentTypeGroupIndex: $contentTypeGroupIndex
    languageIsoCode: $languageIsoCode
  )
}
    `;
export type ContentTranslationApprovalMutationFn = Apollo.MutationFunction<ContentTranslationApprovalMutation, ContentTranslationApprovalMutationVariables>;

/**
 * __useContentTranslationApprovalMutation__
 *
 * To run a mutation, you first call `useContentTranslationApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentTranslationApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentTranslationApprovalMutation, { data, loading, error }] = useContentTranslationApprovalMutation({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *      contentType: // value for 'contentType'
 *      contentTypeGroup: // value for 'contentTypeGroup'
 *      contentTypeGroupIndex: // value for 'contentTypeGroupIndex'
 *      languageIsoCode: // value for 'languageIsoCode'
 *   },
 * });
 */
export function useContentTranslationApprovalMutation(baseOptions?: Apollo.MutationHookOptions<ContentTranslationApprovalMutation, ContentTranslationApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContentTranslationApprovalMutation, ContentTranslationApprovalMutationVariables>(ContentTranslationApprovalDocument, options);
      }
export type ContentTranslationApprovalMutationHookResult = ReturnType<typeof useContentTranslationApprovalMutation>;
export type ContentTranslationApprovalMutationResult = Apollo.MutationResult<ContentTranslationApprovalMutation>;
export type ContentTranslationApprovalMutationOptions = Apollo.BaseMutationOptions<ContentTranslationApprovalMutation, ContentTranslationApprovalMutationVariables>;
export const UpdatePermissionsDocument = gql`
    mutation UpdatePermissions($hierarchyId: String!, $nodeId: String!, $readRoles: [String!]!, $writeRoles: [String!]!, $readUsers: [String!]!, $writeUsers: [String!]!) {
  updatePermissions(
    hierarchyId: $hierarchyId
    nodeId: $nodeId
    readRoles: $readRoles
    writeRoles: $writeRoles
    readUsers: $readUsers
    writeUsers: $writeUsers
  ) {
    code
    message
    success
    propagationJobId
  }
}
    `;
export type UpdatePermissionsMutationFn = Apollo.MutationFunction<UpdatePermissionsMutation, UpdatePermissionsMutationVariables>;

/**
 * __useUpdatePermissionsMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionsMutation, { data, loading, error }] = useUpdatePermissionsMutation({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *      readRoles: // value for 'readRoles'
 *      writeRoles: // value for 'writeRoles'
 *      readUsers: // value for 'readUsers'
 *      writeUsers: // value for 'writeUsers'
 *   },
 * });
 */
export function useUpdatePermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionsMutation, UpdatePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionsMutation, UpdatePermissionsMutationVariables>(UpdatePermissionsDocument, options);
      }
export type UpdatePermissionsMutationHookResult = ReturnType<typeof useUpdatePermissionsMutation>;
export type UpdatePermissionsMutationResult = Apollo.MutationResult<UpdatePermissionsMutation>;
export type UpdatePermissionsMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionsMutation, UpdatePermissionsMutationVariables>;
export const ApproveContentTypeGroupDocument = gql`
    mutation ApproveContentTypeGroup($hierarchyId: String!, $nodeId: String!, $contentTypeGroup: String) {
  approveContentTypeGroup(
    hierarchyId: $hierarchyId
    nodeId: $nodeId
    contentTypeGroup: $contentTypeGroup
  ) {
    code
    message
    success
  }
}
    `;
export type ApproveContentTypeGroupMutationFn = Apollo.MutationFunction<ApproveContentTypeGroupMutation, ApproveContentTypeGroupMutationVariables>;

/**
 * __useApproveContentTypeGroupMutation__
 *
 * To run a mutation, you first call `useApproveContentTypeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveContentTypeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveContentTypeGroupMutation, { data, loading, error }] = useApproveContentTypeGroupMutation({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *      contentTypeGroup: // value for 'contentTypeGroup'
 *   },
 * });
 */
export function useApproveContentTypeGroupMutation(baseOptions?: Apollo.MutationHookOptions<ApproveContentTypeGroupMutation, ApproveContentTypeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveContentTypeGroupMutation, ApproveContentTypeGroupMutationVariables>(ApproveContentTypeGroupDocument, options);
      }
export type ApproveContentTypeGroupMutationHookResult = ReturnType<typeof useApproveContentTypeGroupMutation>;
export type ApproveContentTypeGroupMutationResult = Apollo.MutationResult<ApproveContentTypeGroupMutation>;
export type ApproveContentTypeGroupMutationOptions = Apollo.BaseMutationOptions<ApproveContentTypeGroupMutation, ApproveContentTypeGroupMutationVariables>;
export const UpdateTranslationStatisticsDocument = gql`
    mutation UpdateTranslationStatistics($modifiedCount: Int!, $keptAsReceivedCount: Int!) {
  updateTranslationStatistics(
    modifiedCount: $modifiedCount
    keptAsReceivedCount: $keptAsReceivedCount
  ) {
    code
    message
  }
}
    `;
export type UpdateTranslationStatisticsMutationFn = Apollo.MutationFunction<UpdateTranslationStatisticsMutation, UpdateTranslationStatisticsMutationVariables>;

/**
 * __useUpdateTranslationStatisticsMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationStatisticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationStatisticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationStatisticsMutation, { data, loading, error }] = useUpdateTranslationStatisticsMutation({
 *   variables: {
 *      modifiedCount: // value for 'modifiedCount'
 *      keptAsReceivedCount: // value for 'keptAsReceivedCount'
 *   },
 * });
 */
export function useUpdateTranslationStatisticsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranslationStatisticsMutation, UpdateTranslationStatisticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranslationStatisticsMutation, UpdateTranslationStatisticsMutationVariables>(UpdateTranslationStatisticsDocument, options);
      }
export type UpdateTranslationStatisticsMutationHookResult = ReturnType<typeof useUpdateTranslationStatisticsMutation>;
export type UpdateTranslationStatisticsMutationResult = Apollo.MutationResult<UpdateTranslationStatisticsMutation>;
export type UpdateTranslationStatisticsMutationOptions = Apollo.BaseMutationOptions<UpdateTranslationStatisticsMutation, UpdateTranslationStatisticsMutationVariables>;
export const GetOneHierarchyDocument = gql`
    query GetOneHierarchy($id: String!, $pagination: Pagination, $nodeFilters: NodeFilter) {
  hierarchies(id: $id) {
    id
    code
    nodes(pagination: $pagination, filters: $nodeFilters) {
      id
      code
      parent
      parentCode
      hasChildren
      totalChildren
      linkedBy {
        code
        nodeId
        hierarchyId
      }
    }
  }
}
    `;

/**
 * __useGetOneHierarchyQuery__
 *
 * To run a query within a React component, call `useGetOneHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneHierarchyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pagination: // value for 'pagination'
 *      nodeFilters: // value for 'nodeFilters'
 *   },
 * });
 */
export function useGetOneHierarchyQuery(baseOptions: Apollo.QueryHookOptions<GetOneHierarchyQuery, GetOneHierarchyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneHierarchyQuery, GetOneHierarchyQueryVariables>(GetOneHierarchyDocument, options);
      }
export function useGetOneHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneHierarchyQuery, GetOneHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneHierarchyQuery, GetOneHierarchyQueryVariables>(GetOneHierarchyDocument, options);
        }
export type GetOneHierarchyQueryHookResult = ReturnType<typeof useGetOneHierarchyQuery>;
export type GetOneHierarchyLazyQueryHookResult = ReturnType<typeof useGetOneHierarchyLazyQuery>;
export type GetOneHierarchyQueryResult = Apollo.QueryResult<GetOneHierarchyQuery, GetOneHierarchyQueryVariables>;
export const CreateHierarchyDocument = gql`
    mutation CreateHierarchy($objectSchema: String!, $code: String!) {
  createHierarchy(objectSchema: $objectSchema, code: $code) {
    code
    message
  }
}
    `;
export type CreateHierarchyMutationFn = Apollo.MutationFunction<CreateHierarchyMutation, CreateHierarchyMutationVariables>;

/**
 * __useCreateHierarchyMutation__
 *
 * To run a mutation, you first call `useCreateHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHierarchyMutation, { data, loading, error }] = useCreateHierarchyMutation({
 *   variables: {
 *      objectSchema: // value for 'objectSchema'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCreateHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<CreateHierarchyMutation, CreateHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHierarchyMutation, CreateHierarchyMutationVariables>(CreateHierarchyDocument, options);
      }
export type CreateHierarchyMutationHookResult = ReturnType<typeof useCreateHierarchyMutation>;
export type CreateHierarchyMutationResult = Apollo.MutationResult<CreateHierarchyMutation>;
export type CreateHierarchyMutationOptions = Apollo.BaseMutationOptions<CreateHierarchyMutation, CreateHierarchyMutationVariables>;
export const DuplicateHierarchyDocument = gql`
    mutation DuplicateHierarchy($aggregateId: String!, $code: String!, $market: String) {
  duplicateHierarchy(aggregateId: $aggregateId, code: $code, market: $market) {
    code
    message
  }
}
    `;
export type DuplicateHierarchyMutationFn = Apollo.MutationFunction<DuplicateHierarchyMutation, DuplicateHierarchyMutationVariables>;

/**
 * __useDuplicateHierarchyMutation__
 *
 * To run a mutation, you first call `useDuplicateHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateHierarchyMutation, { data, loading, error }] = useDuplicateHierarchyMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      code: // value for 'code'
 *      market: // value for 'market'
 *   },
 * });
 */
export function useDuplicateHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateHierarchyMutation, DuplicateHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateHierarchyMutation, DuplicateHierarchyMutationVariables>(DuplicateHierarchyDocument, options);
      }
export type DuplicateHierarchyMutationHookResult = ReturnType<typeof useDuplicateHierarchyMutation>;
export type DuplicateHierarchyMutationResult = Apollo.MutationResult<DuplicateHierarchyMutation>;
export type DuplicateHierarchyMutationOptions = Apollo.BaseMutationOptions<DuplicateHierarchyMutation, DuplicateHierarchyMutationVariables>;
export const CreateNodeDocument = gql`
    mutation CreateNode($aggregateId: String!, $code: String!, $parent: String!) {
  createNode(aggregateId: $aggregateId, code: $code, parent: $parent) {
    code
    message
    success
  }
}
    `;
export type CreateNodeMutationFn = Apollo.MutationFunction<CreateNodeMutation, CreateNodeMutationVariables>;

/**
 * __useCreateNodeMutation__
 *
 * To run a mutation, you first call `useCreateNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNodeMutation, { data, loading, error }] = useCreateNodeMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      code: // value for 'code'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useCreateNodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateNodeMutation, CreateNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNodeMutation, CreateNodeMutationVariables>(CreateNodeDocument, options);
      }
export type CreateNodeMutationHookResult = ReturnType<typeof useCreateNodeMutation>;
export type CreateNodeMutationResult = Apollo.MutationResult<CreateNodeMutation>;
export type CreateNodeMutationOptions = Apollo.BaseMutationOptions<CreateNodeMutation, CreateNodeMutationVariables>;
export const UpdateNodeCodeDocument = gql`
    mutation UpdateNodeCode($aggregateId: String!, $parent: String!, $node: String!, $code: String!) {
  updateNode(aggregateId: $aggregateId, node: $node, code: $code, parent: $parent) {
    code
    message
    success
  }
}
    `;
export type UpdateNodeCodeMutationFn = Apollo.MutationFunction<UpdateNodeCodeMutation, UpdateNodeCodeMutationVariables>;

/**
 * __useUpdateNodeCodeMutation__
 *
 * To run a mutation, you first call `useUpdateNodeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNodeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNodeCodeMutation, { data, loading, error }] = useUpdateNodeCodeMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      parent: // value for 'parent'
 *      node: // value for 'node'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUpdateNodeCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNodeCodeMutation, UpdateNodeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNodeCodeMutation, UpdateNodeCodeMutationVariables>(UpdateNodeCodeDocument, options);
      }
export type UpdateNodeCodeMutationHookResult = ReturnType<typeof useUpdateNodeCodeMutation>;
export type UpdateNodeCodeMutationResult = Apollo.MutationResult<UpdateNodeCodeMutation>;
export type UpdateNodeCodeMutationOptions = Apollo.BaseMutationOptions<UpdateNodeCodeMutation, UpdateNodeCodeMutationVariables>;
export const UpdateHierarchyCodeDocument = gql`
    mutation UpdateHierarchyCode($aggregateId: String!, $objectSchema: String!, $code: String!) {
  updateHierarchy(
    aggregateId: $aggregateId
    objectSchema: $objectSchema
    code: $code
  ) {
    code
    message
    success
  }
}
    `;
export type UpdateHierarchyCodeMutationFn = Apollo.MutationFunction<UpdateHierarchyCodeMutation, UpdateHierarchyCodeMutationVariables>;

/**
 * __useUpdateHierarchyCodeMutation__
 *
 * To run a mutation, you first call `useUpdateHierarchyCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHierarchyCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHierarchyCodeMutation, { data, loading, error }] = useUpdateHierarchyCodeMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      objectSchema: // value for 'objectSchema'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUpdateHierarchyCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHierarchyCodeMutation, UpdateHierarchyCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHierarchyCodeMutation, UpdateHierarchyCodeMutationVariables>(UpdateHierarchyCodeDocument, options);
      }
export type UpdateHierarchyCodeMutationHookResult = ReturnType<typeof useUpdateHierarchyCodeMutation>;
export type UpdateHierarchyCodeMutationResult = Apollo.MutationResult<UpdateHierarchyCodeMutation>;
export type UpdateHierarchyCodeMutationOptions = Apollo.BaseMutationOptions<UpdateHierarchyCodeMutation, UpdateHierarchyCodeMutationVariables>;
export const SetContentDocument = gql`
    mutation SetContent($aggregateId: String!, $parent: String, $node: String!, $contents: [NodeContent!]!, $isCreate: Boolean, $skipTranslation: Boolean!) {
  updateNodeContent(
    aggregateId: $aggregateId
    parent: $parent
    node: $node
    contents: $contents
    isCreate: $isCreate
    skipTranslation: $skipTranslation
  ) {
    code
    message
    success
  }
}
    `;
export type SetContentMutationFn = Apollo.MutationFunction<SetContentMutation, SetContentMutationVariables>;

/**
 * __useSetContentMutation__
 *
 * To run a mutation, you first call `useSetContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContentMutation, { data, loading, error }] = useSetContentMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      parent: // value for 'parent'
 *      node: // value for 'node'
 *      contents: // value for 'contents'
 *      isCreate: // value for 'isCreate'
 *      skipTranslation: // value for 'skipTranslation'
 *   },
 * });
 */
export function useSetContentMutation(baseOptions?: Apollo.MutationHookOptions<SetContentMutation, SetContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContentMutation, SetContentMutationVariables>(SetContentDocument, options);
      }
export type SetContentMutationHookResult = ReturnType<typeof useSetContentMutation>;
export type SetContentMutationResult = Apollo.MutationResult<SetContentMutation>;
export type SetContentMutationOptions = Apollo.BaseMutationOptions<SetContentMutation, SetContentMutationVariables>;
export const UpdatePrototypeDocument = gql`
    mutation UpdatePrototype($node: String!, $contents: [NodeContent!]!, $skipTranslation: Boolean!) {
  updatePrototype(
    node: $node
    contents: $contents
    skipTranslation: $skipTranslation
  ) {
    code
    message
    success
  }
}
    `;
export type UpdatePrototypeMutationFn = Apollo.MutationFunction<UpdatePrototypeMutation, UpdatePrototypeMutationVariables>;

/**
 * __useUpdatePrototypeMutation__
 *
 * To run a mutation, you first call `useUpdatePrototypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrototypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrototypeMutation, { data, loading, error }] = useUpdatePrototypeMutation({
 *   variables: {
 *      node: // value for 'node'
 *      contents: // value for 'contents'
 *      skipTranslation: // value for 'skipTranslation'
 *   },
 * });
 */
export function useUpdatePrototypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrototypeMutation, UpdatePrototypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrototypeMutation, UpdatePrototypeMutationVariables>(UpdatePrototypeDocument, options);
      }
export type UpdatePrototypeMutationHookResult = ReturnType<typeof useUpdatePrototypeMutation>;
export type UpdatePrototypeMutationResult = Apollo.MutationResult<UpdatePrototypeMutation>;
export type UpdatePrototypeMutationOptions = Apollo.BaseMutationOptions<UpdatePrototypeMutation, UpdatePrototypeMutationVariables>;
export const UpdateBulkNodesContentsDocument = gql`
    mutation UpdateBulkNodesContents($aggregateId: String!, $nodes: [BulkNodes!]!) {
  updateBulkNodesContents(aggregateId: $aggregateId, nodes: $nodes) {
    code
    message
    success
  }
}
    `;
export type UpdateBulkNodesContentsMutationFn = Apollo.MutationFunction<UpdateBulkNodesContentsMutation, UpdateBulkNodesContentsMutationVariables>;

/**
 * __useUpdateBulkNodesContentsMutation__
 *
 * To run a mutation, you first call `useUpdateBulkNodesContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulkNodesContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulkNodesContentsMutation, { data, loading, error }] = useUpdateBulkNodesContentsMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      nodes: // value for 'nodes'
 *   },
 * });
 */
export function useUpdateBulkNodesContentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBulkNodesContentsMutation, UpdateBulkNodesContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBulkNodesContentsMutation, UpdateBulkNodesContentsMutationVariables>(UpdateBulkNodesContentsDocument, options);
      }
export type UpdateBulkNodesContentsMutationHookResult = ReturnType<typeof useUpdateBulkNodesContentsMutation>;
export type UpdateBulkNodesContentsMutationResult = Apollo.MutationResult<UpdateBulkNodesContentsMutation>;
export type UpdateBulkNodesContentsMutationOptions = Apollo.BaseMutationOptions<UpdateBulkNodesContentsMutation, UpdateBulkNodesContentsMutationVariables>;
export const UpdateNodeParentDocument = gql`
    mutation UpdateNodeParent($aggregateId: String!, $node: String!, $parent: String!) {
  updateNodeParent(aggregateId: $aggregateId, node: $node, parent: $parent) {
    code
    message
    success
  }
}
    `;
export type UpdateNodeParentMutationFn = Apollo.MutationFunction<UpdateNodeParentMutation, UpdateNodeParentMutationVariables>;

/**
 * __useUpdateNodeParentMutation__
 *
 * To run a mutation, you first call `useUpdateNodeParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNodeParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNodeParentMutation, { data, loading, error }] = useUpdateNodeParentMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      node: // value for 'node'
 *      parent: // value for 'parent'
 *   },
 * });
 */
export function useUpdateNodeParentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNodeParentMutation, UpdateNodeParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNodeParentMutation, UpdateNodeParentMutationVariables>(UpdateNodeParentDocument, options);
      }
export type UpdateNodeParentMutationHookResult = ReturnType<typeof useUpdateNodeParentMutation>;
export type UpdateNodeParentMutationResult = Apollo.MutationResult<UpdateNodeParentMutation>;
export type UpdateNodeParentMutationOptions = Apollo.BaseMutationOptions<UpdateNodeParentMutation, UpdateNodeParentMutationVariables>;
export const PublishDocument = gql`
    mutation publish($hierarchy: String!, $node: String!, $contentTypeGroups: [String!]!) {
  publish(
    hierarchy: $hierarchy
    node: $node
    contentTypeGroups: $contentTypeGroups
  ) {
    code
    success
    message
  }
}
    `;
export type PublishMutationFn = Apollo.MutationFunction<PublishMutation, PublishMutationVariables>;

/**
 * __usePublishMutation__
 *
 * To run a mutation, you first call `usePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMutation, { data, loading, error }] = usePublishMutation({
 *   variables: {
 *      hierarchy: // value for 'hierarchy'
 *      node: // value for 'node'
 *      contentTypeGroups: // value for 'contentTypeGroups'
 *   },
 * });
 */
export function usePublishMutation(baseOptions?: Apollo.MutationHookOptions<PublishMutation, PublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishMutation, PublishMutationVariables>(PublishDocument, options);
      }
export type PublishMutationHookResult = ReturnType<typeof usePublishMutation>;
export type PublishMutationResult = Apollo.MutationResult<PublishMutation>;
export type PublishMutationOptions = Apollo.BaseMutationOptions<PublishMutation, PublishMutationVariables>;
export const UnpublishNodeDocument = gql`
    mutation unpublishNode($hierarchy: String!, $node: String!) {
  unpublish(hierarchy: $hierarchy, node: $node) {
    code
    success
    message
  }
}
    `;
export type UnpublishNodeMutationFn = Apollo.MutationFunction<UnpublishNodeMutation, UnpublishNodeMutationVariables>;

/**
 * __useUnpublishNodeMutation__
 *
 * To run a mutation, you first call `useUnpublishNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishNodeMutation, { data, loading, error }] = useUnpublishNodeMutation({
 *   variables: {
 *      hierarchy: // value for 'hierarchy'
 *      node: // value for 'node'
 *   },
 * });
 */
export function useUnpublishNodeMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishNodeMutation, UnpublishNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishNodeMutation, UnpublishNodeMutationVariables>(UnpublishNodeDocument, options);
      }
export type UnpublishNodeMutationHookResult = ReturnType<typeof useUnpublishNodeMutation>;
export type UnpublishNodeMutationResult = Apollo.MutationResult<UnpublishNodeMutation>;
export type UnpublishNodeMutationOptions = Apollo.BaseMutationOptions<UnpublishNodeMutation, UnpublishNodeMutationVariables>;
export const ToggleDisabledDocument = gql`
    mutation ToggleDisabled($aggregateId: String!, $node: String!) {
  toggleDisabled(aggregateId: $aggregateId, node: $node) {
    code
    success
    message
  }
}
    `;
export type ToggleDisabledMutationFn = Apollo.MutationFunction<ToggleDisabledMutation, ToggleDisabledMutationVariables>;

/**
 * __useToggleDisabledMutation__
 *
 * To run a mutation, you first call `useToggleDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDisabledMutation, { data, loading, error }] = useToggleDisabledMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      node: // value for 'node'
 *   },
 * });
 */
export function useToggleDisabledMutation(baseOptions?: Apollo.MutationHookOptions<ToggleDisabledMutation, ToggleDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleDisabledMutation, ToggleDisabledMutationVariables>(ToggleDisabledDocument, options);
      }
export type ToggleDisabledMutationHookResult = ReturnType<typeof useToggleDisabledMutation>;
export type ToggleDisabledMutationResult = Apollo.MutationResult<ToggleDisabledMutation>;
export type ToggleDisabledMutationOptions = Apollo.BaseMutationOptions<ToggleDisabledMutation, ToggleDisabledMutationVariables>;
export const HierarchiesDocument = gql`
    query Hierarchies {
  hierarchies {
    id
    code
  }
}
    `;

/**
 * __useHierarchiesQuery__
 *
 * To run a query within a React component, call `useHierarchiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHierarchiesQuery(baseOptions?: Apollo.QueryHookOptions<HierarchiesQuery, HierarchiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HierarchiesQuery, HierarchiesQueryVariables>(HierarchiesDocument, options);
      }
export function useHierarchiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HierarchiesQuery, HierarchiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HierarchiesQuery, HierarchiesQueryVariables>(HierarchiesDocument, options);
        }
export type HierarchiesQueryHookResult = ReturnType<typeof useHierarchiesQuery>;
export type HierarchiesLazyQueryHookResult = ReturnType<typeof useHierarchiesLazyQuery>;
export type HierarchiesQueryResult = Apollo.QueryResult<HierarchiesQuery, HierarchiesQueryVariables>;
export const GetCsvUploadDataDocument = gql`
    query GetCsvUploadData($nodeId: String) {
  hierarchies(id: $nodeId) {
    id
    objectSchema {
      contentTypeGroups {
        code
        repeatable
        name {
          languageIsoCode
          value
        }
        contentTypes {
          type
          code
          multiLanguage
          multiValue
          mandatory
          mandatoryForSave {
            isMandatory
            option
            comparator
            value
          }
          name {
            languageIsoCode
            value
          }
          hierarchy
        }
      }
    }
  }
}
    `;

/**
 * __useGetCsvUploadDataQuery__
 *
 * To run a query within a React component, call `useGetCsvUploadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCsvUploadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCsvUploadDataQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useGetCsvUploadDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCsvUploadDataQuery, GetCsvUploadDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCsvUploadDataQuery, GetCsvUploadDataQueryVariables>(GetCsvUploadDataDocument, options);
      }
export function useGetCsvUploadDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCsvUploadDataQuery, GetCsvUploadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCsvUploadDataQuery, GetCsvUploadDataQueryVariables>(GetCsvUploadDataDocument, options);
        }
export type GetCsvUploadDataQueryHookResult = ReturnType<typeof useGetCsvUploadDataQuery>;
export type GetCsvUploadDataLazyQueryHookResult = ReturnType<typeof useGetCsvUploadDataLazyQuery>;
export type GetCsvUploadDataQueryResult = Apollo.QueryResult<GetCsvUploadDataQuery, GetCsvUploadDataQueryVariables>;
export const GetHierarchyNodesDocument = gql`
    query GetHierarchyNodes($hierarchiesId: String, $filters: NodeFilter) {
  hierarchies(id: $hierarchiesId) {
    nodes(filters: $filters) {
      id
      code
    }
  }
}
    `;

/**
 * __useGetHierarchyNodesQuery__
 *
 * To run a query within a React component, call `useGetHierarchyNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHierarchyNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHierarchyNodesQuery({
 *   variables: {
 *      hierarchiesId: // value for 'hierarchiesId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetHierarchyNodesQuery(baseOptions?: Apollo.QueryHookOptions<GetHierarchyNodesQuery, GetHierarchyNodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHierarchyNodesQuery, GetHierarchyNodesQueryVariables>(GetHierarchyNodesDocument, options);
      }
export function useGetHierarchyNodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHierarchyNodesQuery, GetHierarchyNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHierarchyNodesQuery, GetHierarchyNodesQueryVariables>(GetHierarchyNodesDocument, options);
        }
export type GetHierarchyNodesQueryHookResult = ReturnType<typeof useGetHierarchyNodesQuery>;
export type GetHierarchyNodesLazyQueryHookResult = ReturnType<typeof useGetHierarchyNodesLazyQuery>;
export type GetHierarchyNodesQueryResult = Apollo.QueryResult<GetHierarchyNodesQuery, GetHierarchyNodesQueryVariables>;
export const GetObjectSchemaDocument = gql`
    query GetObjectSchema($hierarchiesId: String) {
  hierarchies(id: $hierarchiesId) {
    objectSchema {
      code
    }
  }
}
    `;

/**
 * __useGetObjectSchemaQuery__
 *
 * To run a query within a React component, call `useGetObjectSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectSchemaQuery({
 *   variables: {
 *      hierarchiesId: // value for 'hierarchiesId'
 *   },
 * });
 */
export function useGetObjectSchemaQuery(baseOptions?: Apollo.QueryHookOptions<GetObjectSchemaQuery, GetObjectSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjectSchemaQuery, GetObjectSchemaQueryVariables>(GetObjectSchemaDocument, options);
      }
export function useGetObjectSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjectSchemaQuery, GetObjectSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjectSchemaQuery, GetObjectSchemaQueryVariables>(GetObjectSchemaDocument, options);
        }
export type GetObjectSchemaQueryHookResult = ReturnType<typeof useGetObjectSchemaQuery>;
export type GetObjectSchemaLazyQueryHookResult = ReturnType<typeof useGetObjectSchemaLazyQuery>;
export type GetObjectSchemaQueryResult = Apollo.QueryResult<GetObjectSchemaQuery, GetObjectSchemaQueryVariables>;
export const GetObjectSchemaDetailDocument = gql`
    query GetObjectSchemaDetail($hierarchiesId: String) {
  hierarchies(id: $hierarchiesId) {
    id
    code
    objectSchema {
      id
      code
      automaticParentCreation
      disableDeleteHierarchy
      disableDelete
      disableEditCode
      contentTypeGroups {
        code
        repeatable
        roles
        name {
          languageIsoCode
          value
        }
        contentTypes {
          name {
            languageIsoCode
            value
          }
          optionalValues {
            value {
              languageIsoCode
              value
            }
            code
          }
          optionsSource {
            kind
            contentTypeCode
          }
          code
          hierarchy
          type
          multiLanguage
          multiValue
          mandatory
          mandatoryForSave {
            isMandatory
            option
            comparator
            value
          }
          kind
          workflowCode
          link
          search
          depthFilter
          filters {
            code
            value
            comparator
            id
            editable
          }
          dynamicFilters {
            code
            value
            comparator
            id
            editable
          }
          hidden
          regex
          dynamicRegex {
            regex
            option
            comparator
            value
            id
          }
          visibility {
            operator
            visibilityRules {
              option
              comparator
              value
              id
            }
          }
          dynamicReadonly {
            operator
            message
            dynamicReadonlyRules {
              kind
              option
              comparator
              value
              id
            }
          }
          readOnly
          inheritedReadOnly
          autoFilled
          enableRange
          allowPastDates
          showAsPercentage
          disableThousandsSeparator
          columnSize
          encryptAtRest
          maskOnUi
        }
      }
    }
  }
}
    `;

/**
 * __useGetObjectSchemaDetailQuery__
 *
 * To run a query within a React component, call `useGetObjectSchemaDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectSchemaDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectSchemaDetailQuery({
 *   variables: {
 *      hierarchiesId: // value for 'hierarchiesId'
 *   },
 * });
 */
export function useGetObjectSchemaDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetObjectSchemaDetailQuery, GetObjectSchemaDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjectSchemaDetailQuery, GetObjectSchemaDetailQueryVariables>(GetObjectSchemaDetailDocument, options);
      }
export function useGetObjectSchemaDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjectSchemaDetailQuery, GetObjectSchemaDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjectSchemaDetailQuery, GetObjectSchemaDetailQueryVariables>(GetObjectSchemaDetailDocument, options);
        }
export type GetObjectSchemaDetailQueryHookResult = ReturnType<typeof useGetObjectSchemaDetailQuery>;
export type GetObjectSchemaDetailLazyQueryHookResult = ReturnType<typeof useGetObjectSchemaDetailLazyQuery>;
export type GetObjectSchemaDetailQueryResult = Apollo.QueryResult<GetObjectSchemaDetailQuery, GetObjectSchemaDetailQueryVariables>;
export const GetNodeCodeDocument = gql`
    query GetNodeCode($hierarchiesId: String, $nodeFilter: NodeFilter) {
  hierarchies(id: $hierarchiesId) {
    id
    nodes(filters: $nodeFilter) {
      id
      code
      listName
      writeRoles
      writeUsers
    }
  }
}
    `;

/**
 * __useGetNodeCodeQuery__
 *
 * To run a query within a React component, call `useGetNodeCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeCodeQuery({
 *   variables: {
 *      hierarchiesId: // value for 'hierarchiesId'
 *      nodeFilter: // value for 'nodeFilter'
 *   },
 * });
 */
export function useGetNodeCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetNodeCodeQuery, GetNodeCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeCodeQuery, GetNodeCodeQueryVariables>(GetNodeCodeDocument, options);
      }
export function useGetNodeCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeCodeQuery, GetNodeCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeCodeQuery, GetNodeCodeQueryVariables>(GetNodeCodeDocument, options);
        }
export type GetNodeCodeQueryHookResult = ReturnType<typeof useGetNodeCodeQuery>;
export type GetNodeCodeLazyQueryHookResult = ReturnType<typeof useGetNodeCodeLazyQuery>;
export type GetNodeCodeQueryResult = Apollo.QueryResult<GetNodeCodeQuery, GetNodeCodeQueryVariables>;
export const GetNodeDocument = gql`
    query GetNode($hierarchiesId: String, $nodeFilter: NodeFilter, $isInTranslation: Boolean, $transformNodes: Boolean) {
  hierarchies(id: $hierarchiesId) {
    id
    code
    nodes(
      filters: $nodeFilter
      isInTranslation: $isInTranslation
      transformNodes: $transformNodes
    ) {
      id
      _rev
      code
      parent
      listName
      disabled
      readonlyState {
        locked
        excludedFields
        message
        error
      }
      contentTypeGroupStatus {
        code
        status
        publishedAt
      }
      contents {
        contentType
        contentTypeGroup
        contentTypeGroupIndex
        type
        inherited
        valueDecryptionFailed
        value {
          code
          value
          languageIsoCode
          measure
          translate
          approvedValue
          translating
          autoGenerated
        }
      }
      linkedBy {
        code
        nodeId
        hierarchyId
        listName
        order
        linkedNodes {
          code
          nodeId
          hierarchyId
          listName
          order
        }
      }
      readRoles
      writeRoles
      readUsers
      writeUsers
      nodePublished
      createdAt
      updatedAt
      metadata {
        updatedBy
      }
      assignedOwner {
        id
        code
        listName
      }
      assignedDealership {
        id
        code
        listName
      }
      assignedClient {
        id
        code
        listName
      }
      assignedMarket {
        id
        code
        listName
      }
    }
    objectSchema {
      id
      code
      codeCreationExpression
      automaticParentCreation
      codeLabel
      showListNameInEdit
      enablePublish
      bulkPublish
      showPublishInfo
      enableOwner
      hideDisableToggle
      hideDisableToggleDepths
      hideChangeParent
      linkedNodeDeleteStrategy
      disableDeleteHierarchy
      disableDelete
      disableEditCode
      isReferenced
      contentTypeGroups {
        showLevel
        code
        repeatable
        collapsed
        roles
        approveRoles
        name {
          languageIsoCode
          value
        }
        contentTypes {
          name {
            languageIsoCode
            value
          }
          optionalValues {
            value {
              languageIsoCode
              value
            }
            code
          }
          optionsSource {
            kind
            contentTypeCode
          }
          code
          hierarchy
          type
          multiLanguage
          multiValue
          multiLine
          allowExternalUrl
          mandatory
          mediaFolder
          disableNodeCreation
          disableEditAction
          enableXlsxExport
          compactView
          creatable
          showCode
          workflowCode
          allowDuplicateOptionsCode
          disallowEqualCodeAndValue
          mandatoryForSave {
            isMandatory
            option
            comparator
            value
          }
          kind
          link
          search
          depthFilter
          filters {
            code
            value
            comparator
            id
            editable
          }
          dynamicFilters {
            code
            value
            comparator
            id
            editable
          }
          hidden
          regex
          dynamicRegex {
            regex
            option
            comparator
            value
            id
          }
          visibility {
            operator
            visibilityRules {
              option
              comparator
              value
              id
            }
          }
          dynamicReadonly {
            operator
            message
            dynamicReadonlyRules {
              kind
              option
              comparator
              value
              id
            }
          }
          readOnly
          inheritedReadOnly
          autoFilled
          enableRange
          allowPastDates
          showAsPercentage
          disableThousandsSeparator
          additionalInfo {
            fieldCode
            fieldName
            fieldType
            showOnLinkTable
            hierarchy
            multiValue
            linkedByRowNode
            jsonDataFormula
            readonly
          }
          columnSize
          encryptAtRest
          maskOnUi
        }
      }
    }
  }
}
    `;

/**
 * __useGetNodeQuery__
 *
 * To run a query within a React component, call `useGetNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeQuery({
 *   variables: {
 *      hierarchiesId: // value for 'hierarchiesId'
 *      nodeFilter: // value for 'nodeFilter'
 *      isInTranslation: // value for 'isInTranslation'
 *      transformNodes: // value for 'transformNodes'
 *   },
 * });
 */
export function useGetNodeQuery(baseOptions?: Apollo.QueryHookOptions<GetNodeQuery, GetNodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
      }
export function useGetNodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeQuery, GetNodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
        }
export type GetNodeQueryHookResult = ReturnType<typeof useGetNodeQuery>;
export type GetNodeLazyQueryHookResult = ReturnType<typeof useGetNodeLazyQuery>;
export type GetNodeQueryResult = Apollo.QueryResult<GetNodeQuery, GetNodeQueryVariables>;
export const GetNodeChildrenDocument = gql`
    query GetNodeChildren($hierarchiesId: String, $nodeFilter: NodeFilter, $pagination: Pagination) {
  hierarchies(id: $hierarchiesId) {
    id
    code
    currentNode: nodes(filters: $nodeFilter, pagination: $pagination) {
      id
      code
      parent
      hasChildren
      totalChildren
    }
    nodes(filters: $nodeFilter, pagination: $pagination) {
      id
      code
      parent
      hasChildren
      totalChildren
      contentTypeGroupStatus {
        code
        status
      }
    }
    objectSchema {
      contentTypeGroups {
        code
      }
    }
  }
}
    `;

/**
 * __useGetNodeChildrenQuery__
 *
 * To run a query within a React component, call `useGetNodeChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeChildrenQuery({
 *   variables: {
 *      hierarchiesId: // value for 'hierarchiesId'
 *      nodeFilter: // value for 'nodeFilter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNodeChildrenQuery(baseOptions?: Apollo.QueryHookOptions<GetNodeChildrenQuery, GetNodeChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeChildrenQuery, GetNodeChildrenQueryVariables>(GetNodeChildrenDocument, options);
      }
export function useGetNodeChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeChildrenQuery, GetNodeChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeChildrenQuery, GetNodeChildrenQueryVariables>(GetNodeChildrenDocument, options);
        }
export type GetNodeChildrenQueryHookResult = ReturnType<typeof useGetNodeChildrenQuery>;
export type GetNodeChildrenLazyQueryHookResult = ReturnType<typeof useGetNodeChildrenLazyQuery>;
export type GetNodeChildrenQueryResult = Apollo.QueryResult<GetNodeChildrenQuery, GetNodeChildrenQueryVariables>;
export const GetNodeDisabledDocument = gql`
    query GetNodeDisabled($id: String, $nodeFilter: NodeFilter) {
  hierarchies(id: $id) {
    id
    code
    nodes(filters: $nodeFilter) {
      disabled
    }
  }
}
    `;

/**
 * __useGetNodeDisabledQuery__
 *
 * To run a query within a React component, call `useGetNodeDisabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeDisabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeDisabledQuery({
 *   variables: {
 *      id: // value for 'id'
 *      nodeFilter: // value for 'nodeFilter'
 *   },
 * });
 */
export function useGetNodeDisabledQuery(baseOptions?: Apollo.QueryHookOptions<GetNodeDisabledQuery, GetNodeDisabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeDisabledQuery, GetNodeDisabledQueryVariables>(GetNodeDisabledDocument, options);
      }
export function useGetNodeDisabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeDisabledQuery, GetNodeDisabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeDisabledQuery, GetNodeDisabledQueryVariables>(GetNodeDisabledDocument, options);
        }
export type GetNodeDisabledQueryHookResult = ReturnType<typeof useGetNodeDisabledQuery>;
export type GetNodeDisabledLazyQueryHookResult = ReturnType<typeof useGetNodeDisabledLazyQuery>;
export type GetNodeDisabledQueryResult = Apollo.QueryResult<GetNodeDisabledQuery, GetNodeDisabledQueryVariables>;
export const GetShortListBuildupDiffDocument = gql`
    query GetShortListBuildupDiff($shortListId: String!) {
  getShortListBuildupDiff(shortListId: $shortListId) {
    familyId
    prototypes {
      prototypeId
      prototypeCode
      fields {
        code
        certified
        draft
      }
    }
  }
}
    `;

/**
 * __useGetShortListBuildupDiffQuery__
 *
 * To run a query within a React component, call `useGetShortListBuildupDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShortListBuildupDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShortListBuildupDiffQuery({
 *   variables: {
 *      shortListId: // value for 'shortListId'
 *   },
 * });
 */
export function useGetShortListBuildupDiffQuery(baseOptions: Apollo.QueryHookOptions<GetShortListBuildupDiffQuery, GetShortListBuildupDiffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShortListBuildupDiffQuery, GetShortListBuildupDiffQueryVariables>(GetShortListBuildupDiffDocument, options);
      }
export function useGetShortListBuildupDiffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShortListBuildupDiffQuery, GetShortListBuildupDiffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShortListBuildupDiffQuery, GetShortListBuildupDiffQueryVariables>(GetShortListBuildupDiffDocument, options);
        }
export type GetShortListBuildupDiffQueryHookResult = ReturnType<typeof useGetShortListBuildupDiffQuery>;
export type GetShortListBuildupDiffLazyQueryHookResult = ReturnType<typeof useGetShortListBuildupDiffLazyQuery>;
export type GetShortListBuildupDiffQueryResult = Apollo.QueryResult<GetShortListBuildupDiffQuery, GetShortListBuildupDiffQueryVariables>;
export const UpdateListNameDocument = gql`
    mutation UpdateListName($objectSchema: String!, $listName: String!) {
  updateListName(objectSchema: $objectSchema, listName: $listName)
}
    `;
export type UpdateListNameMutationFn = Apollo.MutationFunction<UpdateListNameMutation, UpdateListNameMutationVariables>;

/**
 * __useUpdateListNameMutation__
 *
 * To run a mutation, you first call `useUpdateListNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListNameMutation, { data, loading, error }] = useUpdateListNameMutation({
 *   variables: {
 *      objectSchema: // value for 'objectSchema'
 *      listName: // value for 'listName'
 *   },
 * });
 */
export function useUpdateListNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListNameMutation, UpdateListNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListNameMutation, UpdateListNameMutationVariables>(UpdateListNameDocument, options);
      }
export type UpdateListNameMutationHookResult = ReturnType<typeof useUpdateListNameMutation>;
export type UpdateListNameMutationResult = Apollo.MutationResult<UpdateListNameMutation>;
export type UpdateListNameMutationOptions = Apollo.BaseMutationOptions<UpdateListNameMutation, UpdateListNameMutationVariables>;
export const ChangeNodesOrderDocument = gql`
    mutation ChangeNodesOrder($hierarchyId: String!, $parentId: String!, $nodeOrder: [OrderNode!]!) {
  changeNodesOrder(
    hierarchyId: $hierarchyId
    parentId: $parentId
    nodeOrder: $nodeOrder
  ) {
    code
    success
    message
  }
}
    `;
export type ChangeNodesOrderMutationFn = Apollo.MutationFunction<ChangeNodesOrderMutation, ChangeNodesOrderMutationVariables>;

/**
 * __useChangeNodesOrderMutation__
 *
 * To run a mutation, you first call `useChangeNodesOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeNodesOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeNodesOrderMutation, { data, loading, error }] = useChangeNodesOrderMutation({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      parentId: // value for 'parentId'
 *      nodeOrder: // value for 'nodeOrder'
 *   },
 * });
 */
export function useChangeNodesOrderMutation(baseOptions?: Apollo.MutationHookOptions<ChangeNodesOrderMutation, ChangeNodesOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeNodesOrderMutation, ChangeNodesOrderMutationVariables>(ChangeNodesOrderDocument, options);
      }
export type ChangeNodesOrderMutationHookResult = ReturnType<typeof useChangeNodesOrderMutation>;
export type ChangeNodesOrderMutationResult = Apollo.MutationResult<ChangeNodesOrderMutation>;
export type ChangeNodesOrderMutationOptions = Apollo.BaseMutationOptions<ChangeNodesOrderMutation, ChangeNodesOrderMutationVariables>;
export const AlignModelGlsDocument = gql`
    mutation AlignModelGls($modelId: String!, $misalignedGlsIds: [String!]!) {
  alignModelGls(modelId: $modelId, misalignedGlsIds: $misalignedGlsIds) {
    success
    successfullyUpdatedGls
    errors
  }
}
    `;
export type AlignModelGlsMutationFn = Apollo.MutationFunction<AlignModelGlsMutation, AlignModelGlsMutationVariables>;

/**
 * __useAlignModelGlsMutation__
 *
 * To run a mutation, you first call `useAlignModelGlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlignModelGlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alignModelGlsMutation, { data, loading, error }] = useAlignModelGlsMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      misalignedGlsIds: // value for 'misalignedGlsIds'
 *   },
 * });
 */
export function useAlignModelGlsMutation(baseOptions?: Apollo.MutationHookOptions<AlignModelGlsMutation, AlignModelGlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlignModelGlsMutation, AlignModelGlsMutationVariables>(AlignModelGlsDocument, options);
      }
export type AlignModelGlsMutationHookResult = ReturnType<typeof useAlignModelGlsMutation>;
export type AlignModelGlsMutationResult = Apollo.MutationResult<AlignModelGlsMutation>;
export type AlignModelGlsMutationOptions = Apollo.BaseMutationOptions<AlignModelGlsMutation, AlignModelGlsMutationVariables>;